//** Component  */
import React from "react";
//** Lib */
import RPARequestGroup from "./RPARequestGroup";
import { securityKey } from "../../navigation/SecurityKey";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";


function RPARequestGroupList() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.RPAREQUESTGROUPOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.RPAREQUESTGROUPARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: < RPARequestGroup openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <RPARequestGroup openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <CustomTab data={data} />
  );
}

export default RPARequestGroupList;
